<template>
  <div class="max-w-2xl mx-auto mt-8">
    <!-- text-3xl font-bold text-center md:text-4xl font-GDSage-Bold -->

    <h1
      class="font-sans text-xl font-semibold text-center md:text-center md:font-bold md:text-3xl"
    >
      See how Hutloop can help
    </h1>
  </div>
  <div class="hidden max-w-4xl mx-auto mt-5 md:flex">
    <div class="grid grid-cols-3 gap-5">
      <div class="flex flex-col items-center">
        <img
          src="@/assets/images/BuyAHome.svg"
          class="md:h-32 md:w-32 h-28 w-28"
          alt=""
        />
        <h3 class="font-semibold">Buy a home</h3>
        <p class="text-sm text-center text-gray-700">
          Take a deep dive and browse homes for sale with original photos to
          find what is right for you.
        </p>
        <router-link
          :to="{
            name: 'properties',
            params: {
              slug: 'properties-for-sale',
            },
          }"
          @click="setActiveLink('buy')"
          :class="{ 'active-link': activeLink === 'rent' }"
          class="bg-primary group relative overflow-hidden md:text-sm text-xs border-primary border font-medium md:w-36 mt-3 hover:bg-transparent hover:text-primary rounded p-2 text-white flex md:space-x-2 items-center justify-center md:h-[32px]"
        >
          <span>Find a home</span>
          <svg
            class="z-40 w-3 h-3 ml-2 -mr-1 transition-all duration-300 group-hover:translate-x-1"
            fill="currentColor"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z"
              clip-rule="evenodd"
            ></path>
          </svg>
          <div
            class="absolute inset-0 h-[200%] w-[200%] rotate-45 translate-x-[-70%] transition-all group-hover:scale-100 bg-white/30 group-hover:translate-x-[50%] z-20 duration-1000"
          ></div>
        </router-link>
      </div>
      <div class="flex flex-col items-center">
        <img
          src="@/assets/images/RentAHome.svg"
          class="md:h-32 md:w-32 h-28 w-28"
          alt=""
        />
        <h3 class="font-semibold">Rent a home</h3>
        <p class="text-sm text-center text-[#606060]">
          With over a thousand homes available, Hutloop matches you with a house
          you will call home.
        </p>
        <router-link
          :to="{
            name: 'properties',
            params: {
              slug: 'properties-for-rent',
            },
          }"
          @click="setActiveLink('rent')"
          :class="{ 'active-link': activeLink === 'rent' }"
          class="bg-primary group relative overflow-hidden md:text-sm text-xs border-primary border font-medium md:w-36 mt-3 hover:bg-transparent hover:text-primary rounded p-2 text-white flex md:space-x-2 items-center justify-center md:h-[32px]"
        >
          <span>Find a rental</span>
          <svg
            class="z-40 w-3 h-3 ml-2 -mr-1 transition-all duration-300 group-hover:translate-x-1"
            fill="currentColor"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z"
              clip-rule="evenodd"
            ></path>
          </svg>
          <div
            class="absolute inset-0 h-[200%] w-[200%] rotate-45 translate-x-[-70%] transition-all group-hover:scale-100 bg-white/30 group-hover:translate-x-[50%] z-20 duration-1000"
          ></div>
        </router-link>
      </div>
      <div class="flex flex-col items-center">
        <img
          src="@/assets/images/Neighborhoods.svg"
          class="md:h-32 md:w-32 h-28 w-28"
          alt=""
        />
        <h3 class="font-semibold">Sell a home</h3>
        <p class="text-sm text-center text-[#606060]">
          Hutloop connects hundreds of users on our website everyday to your
          property, and with insight.
        </p>
        <a
          href="/registration-enquiry"
          class="bg-primary group relative overflow-hidden md:text-sm text-xs border-primary border font-medium md:w-36 mt-3 hover:bg-transparent hover:text-primary rounded p-2 text-white flex md:space-x-2 items-center justify-center md:h-[32px]"
        >
          Learn more
          <svg
            class="z-40 w-3 h-3 ml-2 -mr-1 transition-all duration-300 group-hover:translate-x-1"
            fill="currentColor"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z"
              clip-rule="evenodd"
            ></path>
          </svg>
          <div
            class="absolute inset-0 h-[200%] w-[200%] rotate-45 translate-x-[-70%] transition-all group-hover:scale-100 bg-white/30 group-hover:translate-x-[50%] z-20 duration-1000"
          ></div>
        </a>
      </div>
    </div>
  </div>
  <div class="flex mx-4 md:hidden">
    <vue-horizontal
      responsive
      class="horizontal"
      :displacement="0.7"
      snap="center"
    >
      <div class="flex space-x-4">
        <div class="flex flex-col items-center w-full">
          <img
            src="@/assets/images/BuyAHome.svg"
            class="md:h-32 md:w-32 h-28 w-28"
            alt=""
          />
          <h3 class="font-semibold md:text-xl">Buy a home</h3>
          <p class="text-sm text-center md:text-base text-[#606060]">
            Take a deep dive and browse homes for sale with original photos to
            find what is right for you.
          </p>
          <router-link
            :to="{
              name: 'properties',
              params: {
                slug: 'properties-for-sale',
              },
            }"
            @click="setActiveLink('buy')"
            :class="{ 'active-link': activeLink === 'rent' }"
            class="bg-primary group relative overflow-hidden md:text-base text-xs border-primary border font-medium md:w-40 mt-3 hover:bg-transparent hover:text-primary rounded p-2 text-white flex md:space-x-2 items-center justify-center md:h-[36px]"
          >
            <span>Find a home</span>
            <svg
              class="z-40 w-3 h-3 ml-2 -mr-1 transition-all duration-300 group-hover:translate-x-1"
              fill="currentColor"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z"
                clip-rule="evenodd"
              ></path>
            </svg>
            <div
              class="absolute inset-0 h-[200%] w-[200%] rotate-45 translate-x-[-70%] transition-all group-hover:scale-100 bg-white/30 group-hover:translate-x-[50%] z-20 duration-1000"
            ></div>
          </router-link>
        </div>
        <div class="flex flex-col items-center w-full">
          <img
            src="@/assets/images/RentAHome.svg"
            class="md:h-32 md:w-32 h-28 w-28"
            alt=""
          />
          <h3 class="font-semibold md:text-xl">Rent a home</h3>
          <p class="text-sm text-center md:text-base text-[#606060]">
            With over a thousand homes available, Hutloop matches you with a
            house you will call home.
          </p>
          <router-link
            :to="{
              name: 'properties',
              params: {
                slug: 'properties-for-rent',
              },
            }"
            @click="setActiveLink('rent')"
            :class="{ 'active-link': activeLink === 'rent' }"
            class="bg-primary group relative overflow-hidden md:text-base text-xs border-primary border font-medium md:w-40 mt-3 hover:bg-transparent hover:text-primary rounded p-2 text-white flex md:space-x-2 items-center justify-center md:h-[36px]"
          >
            <span>Find a rental</span>
            <svg
              class="z-40 w-3 h-3 ml-2 -mr-1 transition-all duration-300 group-hover:translate-x-1"
              fill="currentColor"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z"
                clip-rule="evenodd"
              ></path>
            </svg>
            <div
              class="absolute inset-0 h-[200%] w-[200%] rotate-45 translate-x-[-70%] transition-all group-hover:scale-100 bg-white/30 group-hover:translate-x-[50%] z-20 duration-1000"
            ></div>
          </router-link>
        </div>
        <div class="flex flex-col items-center w-full">
          <img
            src="@/assets/images/Neighborhoods.svg"
            class="md:h-32 md:w-32 h-28 w-28"
            alt=""
          />
          <h3 class="font-semibold md:text-xl">Sell a home</h3>
          <p class="text-sm text-center md:text-base text-[#606060]">
            Hutloop connects hundreds of users on our website everyday to your
            property, and with insight.
          </p>
          <a
            href="/registration-enquiry"
            class="bg-primary group relative overflow-hidden md:text-base text-xs border-primary border font-medium md:w-40 mt-3 hover:bg-transparent hover:text-primary rounded p-2 text-white flex md:space-x-2 items-center justify-center md:h-[36px]"
          >
            Learn more
            <svg
              class="z-40 w-3 h-3 ml-2 -mr-1 transition-all duration-300 group-hover:translate-x-1"
              fill="currentColor"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z"
                clip-rule="evenodd"
              ></path>
            </svg>
            <div
              class="absolute inset-0 h-[200%] w-[200%] rotate-45 translate-x-[-70%] transition-all group-hover:scale-100 bg-white/30 group-hover:translate-x-[50%] z-20 duration-1000"
            ></div>
          </a>
        </div>
      </div>
    </vue-horizontal>
  </div>
</template>
<script>
import VueHorizontal from "vue-horizontal";
export default {
  components: {
    VueHorizontal,
  },
  data() {
    return {
      activeLink: localStorage.getItem("activeLink") || "",
    };
  },
  props: {
    settings: Object,
  },
  methods: {
    setActiveLink(link) {
      this.activeLink = link;
      // Store active link in localStorage
      localStorage.setItem("activeLink", link);
    },
  },
};
</script>
<style>
.transition-transform {
  transition: transform 0.3s ease; /* Add transition for smooth effect */
}

.hover\:hover\:hover\:transform-gpu:hover {
  transform: translateX(5px); /* Adjust the value based on your preference */
}

.nav-link {
  font-weight: normal;
  transition: font-weight 0.2s ease;
}
.active-link {
  font-weight: bolder !important;
  color: #ef5d4e !important;
}
</style>

<!-- <style scoped>
/* Content styling is done with tailwind postcss @apply for brevity. */

header {
  @apply mb-4 flex justify-between items-center;
}

nav > button {
  @apply p-1 rounded-sm outline-none;
}

nav > button.active {
  @apply text-gray-700;
}

nav > button.inactive {
  @apply text-gray-300;
}

nav > button:focus {
  @apply outline-none;
}

nav > button > svg {
  @apply h-6 w-6 fill-current;
}
</style> -->
